import {
  Component,
  OnInit,
  ViewChild,
  OnDestroy,
  ElementRef,
  AfterViewInit,
  ChangeDetectorRef,
  HostListener,
} from "@angular/core";
import { ROUTES } from "./vertical-menu-routes.config";
import { HROUTES } from "../horizontal-menu/navigation-routes.config";

import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { customAnimations } from "../animations/custom-animations";
import { DeviceDetectorService } from "ngx-device-detector";
import { ConfigService } from "../services/config.service";
import { Observable, Subscription } from "rxjs";
import { LayoutService } from "../services/layout.service";
import { UserService } from "../services/data/user-service";
import { first, map } from "rxjs/operators";
import { User } from "app/model/user";
import { LoginService } from "../services/login/login.service";
import { Roles } from "app/model/rol";

@Component({
  selector: "app-sidebar",
  templateUrl: "./vertical-menu.component.html",
  styleUrls: ["./vertical-menu.component.scss"],
  animations: customAnimations,
})
export class VerticalMenuComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly LIGHT_LOGO: string = 'assets/img/logo.png'
  private readonly DARK_LOGO: string = 'assets/img/logo-dark.png'

  @ViewChild("toggleIcon") toggleIcon: ElementRef;
  public menuItems: any[];
  level: number = 0;
  public logoUrl: string;
  public config: any = {};
  protected innerWidth: any;
  layoutSub: Subscription;
  configSub: Subscription;
  userRoles: string[] = [];
  perfectScrollbarEnable = true;
  collapseSidebar = false;
  userName: string;
  resizeTimeout;

  constructor(
    private router: Router,
    public translate: TranslateService,
    private loginService: LoginService,
    private layoutService: LayoutService,
    private configService: ConfigService,
    private cdr: ChangeDetectorRef,
    private deviceService: DeviceDetectorService,
    private userService: UserService
  ) {
    this.config = this.configService.templateConf;
    this.innerWidth = window.innerWidth;
    this.isTouchDevice();
  }

  ngOnInit() {
    this.logoUrl = this.DARK_LOGO
    this.userName = sessionStorage.getItem("user");
    this.menuItems = ROUTES;
    this.getUserRol();
  }

  getUserRol() {
    const tokenStr = sessionStorage.getItem("token");
    this.loginService
      .getCurrentUser(tokenStr)
      .pipe(map((data) => data as User))
      .subscribe(
        (data) => {
          this.userRoles = data.userRoles.map((rol) => rol.name);
          if (this.userRoles.includes(Roles.ADMIN_ROLE)) {

          } // Filtrar el arreglo menuItems para ocultar el elemento de comunicación si el usuario es 'Administrador'
          else if (this.userRoles.includes(Roles.LEADER_ROLE) || this.userRoles.includes(Roles.SUPER_LEADER_ROLE)) {

            this.menuItems = this.menuItems.map((item) => {
              if (item.submenu && item.submenu.length > 0) {
                item.submenu = item.submenu.filter(
                  (subitem) => subitem.path !== "/pages/upload-admin"
                );
                item.submenu = item.submenu.filter(
                  (subitem) => subitem.path !== "/pages/users-list"
                );
                item.submenu = item.submenu.filter(
                  (subitem) => subitem.path !== "/pages/users-edit"
                );
                item.submenu = item.submenu.filter(
                  (subitem) => subitem.path !== "/pages/users-new"
                );
                item.submenu = item.submenu.filter(
                  (subitem) => subitem.path !== "/pages/upload"
                );
                // item.submenu = item.submenu.filter(subitem => subitem.path !== '/pages/calendar-admin');
                item.submenu = item.submenu.filter(
                  (subitem) => subitem.path !== "/pages/setting-admin"
                );
                item.submenu = item.submenu.filter(
                  (subitem) => subitem.path !== "/pages/account-settings"
                );
                item.submenu = item.submenu.filter(
                  (subitem) => subitem.path !== "/pages/global-configuration"
                );
              }
              return item;
            });
          } else if (this.userRoles.includes(Roles.USER_ROLE)) {

            this.menuItems = this.menuItems.filter(
              (item) => item.title !== "Administrador" && item.title !== 'Panel de gestión'
            );
          }
          this.cdr.detectChanges();
        },
        (error) => {
          console.error("Error al obtener los datos:", error);
        }
      );
  }

  ngAfterViewInit() {
    this.configSub = this.configService.templateConf$.subscribe(
      (templateConf) => {
        if (templateConf) {
          this.config = templateConf;
        }
        this.loadLayout();
        this.cdr.markForCheck();
      }
    );

    this.layoutSub = this.layoutService.overlaySidebarToggle$.subscribe(
      (collapse) => {
        if (this.config.layout.menuPosition === "Side") {
          this.collapseSidebar = collapse;
        }
      }
    );
  }


  @HostListener('window:resize', ['$event'])
  onWindowResize(event) {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    this.resizeTimeout = setTimeout((() => {
      this.innerWidth = event.target.innerWidth;
      this.loadLayout();
    }).bind(this), 500);
  }

  loadLayout() {
    if (this.config.layout.menuPosition === "Top") {
      // Horizontal Menu
      if (this.innerWidth < 1200) {

        this.menuItems = HROUTES;

      }
    } else if (this.config.layout.menuPosition === "Side") {
      // Vertical Menu{
      //this.menuItems = ROUTES;
      this.menuItems = this.menuItems;
    }

    if (this.config.layout.sidebar.backgroundColor === "white") {
      this.logoUrl = this.DARK_LOGO;
    } else {
      this.logoUrl = this.LIGHT_LOGO;
    }

    if (this.config.layout.sidebar.collapsed) {
      this.collapseSidebar = true;
    } else {
      this.collapseSidebar = false;
    }
  }

  toggleSidebar() {
    let conf = this.config;
    conf.layout.sidebar.collapsed = !this.config.layout.sidebar.collapsed;
    this.configService.applyTemplateConfigChange({ layout: conf.layout });

    setTimeout(() => {
      this.fireRefreshEventOnWindow();
    }, 300);
  }

  fireRefreshEventOnWindow = function () {
    const evt = document.createEvent("HTMLEvents");
    evt.initEvent("resize", true, false);
    window.dispatchEvent(evt);
  };

  CloseSidebar() {
    this.layoutService.toggleSidebarSmallScreen(false);
  }

  isTouchDevice() {
    const isMobile = this.deviceService.isMobile();
    const isTablet = this.deviceService.isTablet();

    if (isMobile || isTablet) {
      this.perfectScrollbarEnable = false;
    } else {
      this.perfectScrollbarEnable = true;
    }
  }

  ngOnDestroy() {
    if (this.layoutSub) {
      this.layoutSub.unsubscribe();
    }
    if (this.configSub) {
      this.configSub.unsubscribe();
    }
  }
}
